module.exports = __webpack_public_path__ + "img/topicDIYGardening.1702eb5d.png";